import React, { useEffect, useState } from 'react';
import { Modal } from 'jd-library';
import ImageIcons from 'jd-library/ImageIcons';
import styles from './commonStyle.scss';
import { useDispatch, useSelector } from 'react-redux';
import { updateDescType, updateEditProductDetail } from '../../actions/products';
import { getDescriptionData } from './utils';
import { getAllSpecificationData } from '../../pages/add-edit-product/c-specification-slider/customActions';
import { showMessage } from "jd-library/src/Toast/ToastAction";

const Loader = ({ percValue, circleRef }) => {

    return (
        <div id="cont" data-pct="100">
            <svg id="svg" width="90px" height="90px" viewPort="0 0 45px 45px" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <circle r="40" cx="45px" cy="45px" fill="transparent" stroke-dasharray="251.2" stroke-dashoffset="0"></circle>
                <circle ref={circleRef} id="bar" r="40" cx="45px" cy="45px" fill="transparent" stroke-dasharray="251.2" stroke-dashoffset={251.2}></circle>
            </svg>
            <div className={styles['fake-div']}>
                <div className={styles['catalogue-percentage']}>{Math.round(percValue)}%</div>
            </div>
        </div>
    )
}

const AILoadingModal = props => {
    const [percValue, setPercValue] = useState(0);
    const [isApiCallDone, setIsApiCallDone] = useState(false)
    const circleRef = React.useRef(null);
    const dispatch = useDispatch();
    const productSpecification = useSelector(state => state.productSpecification)
    const updateLoader = (newVal = 0) => {
        let tempVal = newVal;
        let pct, cf = 252;
        if (tempVal < 0) {
            tempVal = 0;
        }
        else if (tempVal > 100) {
            tempVal = 100;
        }
        if (isNaN(Math.round(tempVal))) {
            tempVal = 0;
        }
        pct = ((100 - tempVal) / 100) * cf;
        setPercValue(tempVal);
        circleRef && circleRef.current && (circleRef.current.style.strokeDashoffset = pct);
    }

    useEffect(() => {
        setIsApiCallDone(false)
        updateLoader(0)
        const timer = setInterval(() => {
            setPercValue((prevVal) => {
                if(prevVal == 90) {
                    clearInterval(timer);
                }else {
                    updateLoader(prevVal + 15)
                }
                return prevVal;
            })
        }, 300);
        const ignoreField = ['brand', 'country_of_origin', 'price', 'manufacturer', 'manufactured_details', 'importer', 'importers_detail', 'packaging_length', 'packaging_width', 'packaging_height', 'packaging_weight', 'expiry_date'];
        const getSpec = getAllSpecificationData(productSpecification.savedPuvSpecAttributes, productSpecification.savedCustomSpecAttributes);
        const filterSpec = getSpec.filter(item => !ignoreField.includes(item.s_name))
        const newAry = []
        filterSpec.slice(0, 7).map(item => {
            const value = typeof item.values == "string" ? item.values : item.values.join(",")
            newAry.push({sid:item?.sid || '',label:item?.name,value:value,isCustom:item?.sid ? false:true})
        })
        const queryString = `product_name=${encodeURIComponent(props.productData.productName)}&product_category=${encodeURIComponent(props.productData.keywordName)}&spec=${encodeURIComponent(JSON.stringify(newAry))}`
        getDescriptionData(queryString,({ status, value, msg }) => {
            if (status) {
                clearInterval(timer);
                props.setReTryAI(true)
                props.togglePaste(false)
                props.updateCount(value.length > 8000 ? 8000 : value.length)
            }else{
                dispatch(showMessage({
                    showToastMessage: true,
                    message: msg,
                    type: 'info',
                    duration: 3000
                }));
            }
            updateLoader(100);
            setTimeout(() => {
                setIsApiCallDone(true)
                setTimeout(() => {
                    window.history.back();
                    dispatch(updateDescType({descType: 2}))
                    dispatch(updateEditProductDetail({ key: "description", value}));
                }, 1500);
            }, 1000);
        })
    }, [])

    return (
        <Modal
            settings={{
                modalId: 'ai-redirect',
                variant: 'action',
                class: styles['ai-modals']
            }}
            backdropStatic
            onHidden={props.onHidden}
        >
            <Modal.Header className={styles['modal-heading']}>
                Please Wait
            </Modal.Header>
            <Modal.Body className={styles['modal-bdy']}>
                <div className={styles['review-redirect']}>
                    <div className={styles['content']}>
                        We are generating an amazing description just for you.
                    </div>
                </div>
                {
                    isApiCallDone ?
                    <div className={styles['success-div']}>
                        <img className={styles["check-mark-icon"]} src={ImageIcons.CHECK_MARK_GIF || ""} alt="" />
                    </div> :
                    <Loader percValue={percValue} circleRef={circleRef} />
                }
            </Modal.Body>
        </Modal>
    )
};

export default AILoadingModal;